module.exports = __webpack_public_path__ + "static/media/21ECLAC41.ed38ba13.jpg";